import { render, staticRenderFns } from "./UserDetailsAffiliateForm.vue?vue&type=template&id=6ceb0bf4&"
import script from "./UserDetailsAffiliateForm.vue?vue&type=script&lang=js&"
export * from "./UserDetailsAffiliateForm.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsAffiliateForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports